import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

export const RadioPanels = <TValue extends string>({
  items,
  value,
  onValueChange,
  orientation = "horizontal",
}: {
  items: {
    value: TValue;
    label: string;
    description?: string;
    icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  }[];
  value: TValue;
  orientation?: "horizontal" | "vertical";
  onValueChange: (value: TValue) => void;
}) => {
  return (
    <RadioGroupPrimitive.Root
      className={`grid w-full gap-3 ${orientation === "horizontal" && "grid-cols-[repeat(auto-fit,minmax(10px,1fr))]"}`}
      id="radio-panel"
      onValueChange={(val: string) => {
        const match = items.find((item) => item.value === val);
        if (match) {
          onValueChange(match.value);
        }
      }}
      orientation={orientation}
      value={value}
    >
      {items.map(({ value: itemValue, label, description, icon: Icon }) => (
        <RadioGroupPrimitive.Item
          className="group border-border data-[state=checked]:ring-foreground space-y-2 rounded-2xl border p-4 text-center transition-[border-color,box-shadow] focus-visible:outline-hidden data-[state=checked]:ring-1"
          key={itemValue}
          value={itemValue}
        >
          {Icon ? <Icon className="text-foreground mx-auto" /> : null}
          <div>
            <p className="subtitle font-heading text-foreground group-data-[state=checked]:text-foreground transition-[color,box-shadow]">
              {label}
            </p>
            {description && (
              <p className="body-sm text-muted-foreground leading-tight">
                {description}
              </p>
            )}
          </div>
        </RadioGroupPrimitive.Item>
      ))}
    </RadioGroupPrimitive.Root>
  );
};
